var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { AlarmSeverityEnum, CompaniesClient, CompanyNotificationSummaryModel, GetNotificationListPaginatedQuery, NotificationChannelEnum, NotificationModel, NotificationPreferencesClient, NotificationsClient, PaginatedEnumerableOfNotificationModel, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import { Alert } from "@/common/utils/alert";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import moment from 'moment';
const companyClient = new CompaniesClient(window.apiUrl);
const notificationsClient = new NotificationsClient(window.apiUrl);
const notificationPreferencesClient = new NotificationPreferencesClient(window.apiUrl);
let NotificationHistoryVue = class NotificationHistoryVue extends Vue {
    constructor() {
        super(...arguments);
        this.placeholderText = "N/A";
        // simpletons
        this.loading = false;
        this.working = false;
        this.searchAttempted = false;
        this.viewingNotification = false;
        // components
        this.msg = new Alert();
        this.sorter = new Sorter(new SortDescription({
            fieldName: "whenAttempted",
            direction: SortDirection.Descending
        }));
        this.datePickerConfig = {
            dateFormat: "d M Y",
            wrap: true,
            enableTime: false,
            allowInput: false
        };
        this.dateFilterOptions = ["1 Day", "3 Days", "5 Days", "Week", "All", "..."];
        this.dateFilterOption = "";
        // models
        this.notification = new NotificationModel();
        this.data = new PaginatedEnumerableOfNotificationModel();
        this.summary = new CompanyNotificationSummaryModel();
        this.query = new GetNotificationListPaginatedQuery({
            systemId: null,
            componentId: null,
            includeDeleted: false,
            includeUnsent: true,
            companyId: null,
            pageNo: 1,
            pageSize: 100,
            keywords: null,
            timezoneOffset: 0,
            sort: this.sorter.currentSort
        });
        // arrays
        this.companies = [];
        this.channels = [
            { value: null, text: `All types` },
            { text: "Email", value: NotificationChannelEnum.Email },
            { text: "SMS", value: NotificationChannelEnum.Sms }
        ];
    }
    created() {
        //this.resetDateFilterOption();
    }
    ;
    mounted() {
        this.getCompanies();
    }
    ;
    search() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            this.working = true;
            this.loading = true;
            let query = this.query;
            let startTime = query.whenCreatedFrom ? DateHelper.convertToDate(query.whenCreatedFrom.toString()) : null;
            let endTime = query.whenCreatedTo ? DateHelper.convertToDate(query.whenCreatedTo.toString()) : null;
            if (endTime != null)
                endTime = DateHelper.getEndOfDay(endTime);
            if (!DateHelper.validateDateRange(startTime, endTime)) {
                this.loading = false;
                this.working = false;
                Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
                return;
            }
            query.whenCreatedFrom = startTime;
            query.whenCreatedTo = endTime;
            query.timezoneOffset = DateHelper.getTimezoneOffset();
            return yield notificationsClient.search(query)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if (response) {
                    this.data = response;
                    this.query.pageNo = this.data.displayedPage;
                    this.query.pageSize = this.data.pageSize;
                }
                yield this.getSummary();
            }))
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.loading = false;
                this.searchAttempted = true;
            });
        });
    }
    ;
    getSummary() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.query.companyId)
                return;
            if (!this.showSummary)
                return;
            this.summary = new CompanyNotificationSummaryModel();
            return yield notificationPreferencesClient
                .getCompanyNotificationSummary(this.query.companyId, DateHelper.getCurrentUTCDateAsString())
                .then(response => {
                this.summary = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            });
        });
    }
    ;
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.sort = this.sorter.currentSort;
            yield this.search();
        });
    }
    ;
    onPageChanged() {
        this.search();
    }
    ;
    onPeriodChanged() {
        if (this.areDatesInvalid || this.startDateInvalid || this.endDateInvalid)
            return;
        this.search();
    }
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
                if (!companies.length)
                    return;
                if (this.query.companyId)
                    return;
                let companyId = companies[0].value;
                this.query.companyId = companyId;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.resetDateFilterOption();
            });
        });
    }
    ;
    getNotification(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            this.working = true;
            return yield notificationsClient.get(notification.messageId)
                .then(response => {
                this.notification = response;
                this.viewingNotification = true;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.pageNo = 1;
            return yield this.search();
        });
    }
    ;
    view(notification) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getNotification(notification).then();
        });
    }
    ;
    cancel() {
        this.notification = new NotificationModel();
        this.viewingNotification = false;
    }
    ;
    alarmClass(notification) {
        if (notification.priority == null)
            return "unknown";
        if (notification.priority == AlarmSeverityEnum.Critical)
            return "critical";
        if (notification.priority == AlarmSeverityEnum.Warning)
            return "warning";
        if (notification.priority == AlarmSeverityEnum.Info)
            return "info";
        return "unknown";
    }
    ;
    whenCreatedTimeString(notification) {
        return DateHelper.convertToFriendlyMomentTimeString(notification.whenCreated);
    }
    ;
    whenAttemptedTimeString(notification) {
        return DateHelper.convertToFriendlyMomentTimeString(notification.whenAttempted || null);
    }
    ;
    get whenLastAlarmEmailCreated() {
        var _a;
        return DateHelper.convertToFriendlyMomentTimeString(((_a = this.summary.emailNotificationSnapshot) === null || _a === void 0 ? void 0 : _a.whenLastAlarmEmailCreated) || null) || this.placeholderText;
    }
    ;
    get whenLastSystemSummaryEmailCreated() {
        var _a;
        return DateHelper.convertToFriendlyMomentTimeString(((_a = this.summary.emailNotificationSnapshot) === null || _a === void 0 ? void 0 : _a.whenLastSystemSummaryEmailCreated) || null) || this.placeholderText;
    }
    ;
    get numberOfEmailsSentToday() {
        var _a, _b;
        return ((_b = (_a = this.summary.emailNotificationSnapshot) === null || _a === void 0 ? void 0 : _a.numberOfEmails) === null || _b === void 0 ? void 0 : _b.toString()) || this.placeholderText;
    }
    ;
    get whenLastAlarmSmsCreated() {
        var _a;
        return DateHelper.convertToFriendlyMomentTimeString(((_a = this.summary.smsNotificationSnapshot) === null || _a === void 0 ? void 0 : _a.whenLastAlarmEmailCreated) || null) || this.placeholderText;
    }
    ;
    get numberOfSmsSentToday() {
        var _a, _b;
        return ((_b = (_a = this.summary.smsNotificationSnapshot) === null || _a === void 0 ? void 0 : _a.numberOfEmails) === null || _b === void 0 ? void 0 : _b.toString()) || this.placeholderText;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedChannelId(item) {
        if (!item)
            return;
        this.query.channelId = item.value;
    }
    ;
    get selectedChannelId() {
        return this.channels.filter(item => {
            return item.value == this.query.channelId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    resetDateFilterOption() {
        this.setDateFilterOption("Week");
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
        this.search();
    }
    ;
    setDateRange() {
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        let now = new Date();
        let end = moment(now.toISOString()).endOf("day").toDate();
        switch (this.dateFilterOption) {
            case "1 Day":
                range = { start: moment(now.toISOString()).add(-1, "days").startOf("day").toDate(), end: end };
                break;
            case "3 Days":
                range = { start: moment(now.toISOString()).add(-3, "days").startOf("day").toDate(), end: end };
                break;
            case "5 Days":
                range = { start: moment(now.toISOString()).add(-5, "days").startOf("day").toDate(), end: end };
                break;
            case "Week":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "All":
                range = { start: null, end: null };
                break;
        }
        if (!range)
            return;
        this.query.whenCreatedFrom = range.start;
        this.query.whenCreatedTo = range.end;
    }
    ;
    get areDatesInvalid() {
        if (this.query.whenCreatedFrom == null || this.query.whenCreatedTo == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.whenCreatedFrom.toString());
        let endTime = DateHelper.convertToDate(this.query.whenCreatedTo.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.query.whenCreatedFrom)
            return true;
        try {
            return isNaN(Date.parse(this.query.whenCreatedFrom.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.whenCreatedTo)
            return true;
        try {
            return isNaN(Date.parse(this.query.whenCreatedTo.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], NotificationHistoryVue.prototype, "showTitle", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], NotificationHistoryVue.prototype, "showSummary", void 0);
__decorate([
    Watch("query.companyId"),
    Watch("query.channelId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], NotificationHistoryVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], NotificationHistoryVue.prototype, "onSortChanged", null);
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NotificationHistoryVue.prototype, "onPageChanged", null);
__decorate([
    Watch("query.whenCreatedFrom"),
    Watch("query.whenCreatedTo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NotificationHistoryVue.prototype, "onPeriodChanged", null);
NotificationHistoryVue = __decorate([
    Component({
        name: "NotificationHistoryVue"
    })
], NotificationHistoryVue);
export default NotificationHistoryVue;
